import React, { Component } from 'react';
import styled from 'styled-components';

import Image from 'partials/Image';
import api from 'api';
import { redirect404 } from 'helpers';
import { h1Styles, h3Styles } from 'partials/typography';
import Html from 'partials/Html';
import { NavLink } from 'react-router-dom';
import ErrorBoundary from 'partials/ErrorBoundary';
import Footer from 'partials/Footer';
import Arrow from 'images/Arrow';
import NotFound from 'partials/NotFound'

class Employee extends Component {
	constructor() {
		super();
		this.state = {
			notFound: false,
			employee: null
		}
	}

	componentDidMount() {
		this.mounted = true;
		this._loadEmployeeData();
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	_loadEmployeeData() {
		api.employeesFetcher.getBySlug({ slug: this.props.match.params.slug })
		.then(response => {
			if(!response.data[0]) {
				this.setState({ notFound: true })
			}
			if(this.mounted) {
				this.setState({ employee: response.data[0]});
			}
		});
	}

	render() {
		const { employee } = this.state;

		if(this.state.notFound) return <NotFound/>

		if(!employee) return null;

		return(
			<React.Fragment>
				<Wrapper>
					<div className="row">
						<ArchiveButton><NavLink className="term-link" to={'/ansatte'} ><Arrow /> <span className="text">Ansatte Oversikt</span></NavLink></ArchiveButton>
						<EmployeeContainer>
								<Image maxHeight="317" image={employee.acf.image} size="large" className="image" background ratio="1:1" />
								<div className="section">
									<div className="name">{ employee.acf.name }</div>
									<div className="title">{ employee.acf.role }</div>
									<Html content className="html-content">{employee.acf.text}</Html>
								</div>
						</EmployeeContainer>
					</div>
				</Wrapper>
	            <ErrorBoundary for="Footer">
	                <Footer />
	            </ErrorBoundary>
	    	</React.Fragment>
		)
	}
}

const Wrapper = styled.div`
	position: relative;
	padding-top: 120px;
	padding-bottom: 120px;
	max-width: 1260px;
	margin-left: auto;
	margin-right: auto;

	.row {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
	}

	@media(max-width: 767px) {
		padding-bottom: 40px;
	}
`;

const ArchiveButton = styled.button`
	position: relative;
	height: auto;
	flex: 0 0 auto;
	padding: 9px 18px 8px 15px;
	background: rgb(36,114,185, 0.1);
	border-radius: 20px;
	margin-top: 74px;

	.term-link {
		font-family: Helvetica;
		font-size: 16px;
		color: #002857;
		line-height: 24px;
	}

	.text {
		margin-left: 10px;
	}

    @media(max-width: 1024px) {
    	margin-left: 15px;
    }
`;


const EmployeeContainer = styled.div`
	position: relative;
	flex: 0 0 100%;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	margin-top: 40px;

	.image {
		flex: 0 0 20%;
	}

	.section {
		padding-left: 40px;
		.name {
		    ${h1Styles}
		    margin-bottom: 10px;
		}

		.title {
		    ${h3Styles}
		    margin-bottom: 25px;
		}
	}

    @media(max-width: 1024px) {

    	.image {
    		margin: 0px 15px;
    	}

    	.section {
    		margin-right: 15px;
    	}
    }

    @media(max-width: 767px) {
    	flex-direction: column;
    	padding-bottom: 0;
    	height: 100%;

    	.section {
    		padding-left: 0;
    		margin: 30px 15px;
    	}

    	.image {
    		min-height: 300px;
    		max-width: calc(100% - 30px);
    	}
    }

    @media(max-width: 480px) {
    	flex: 0 0 100%;

    	.image {
    		min-height: 350px;
    	}
    }


`;

export default Employee;


// WEBPACK FOOTER //
// ./src/views/Employee.js